import { HTTP } from "@/axios_api/http-common";

export const defaultChartData = {
  labels: [],
  datasets: [],
};

export const defaultChartOptions = {
  title: {
    display: true,
    text: "",
  },
  maintainAspectRatio: false,
  responsive: true,
  scales: {
    xAxes: [
      {
        gridLines: {
            color: '#eee', // Red gridlines for the Y-axis
            lineWidth: 1,
        },
        ticks: { beginAtZero: true },
        scaleLabel: {
          display: true,
          labelString: "", // Label for the X axis
        },
      },
    ],
    yAxes: [
      {
        gridLines: {
            color: '#eee', // Red gridlines for the Y-axis
            lineWidth: 1,
        },
        ticks: { beginAtZero: true },
        scaleLabel: {
          display: true,
          labelString: "", // Label for the Y axis
        },
      },
    ],
  },
  layout: {
      padding: {
          left: 10,
          right: 10,
          top: 10,
          bottom: 25
      }
  },
  legend: {
    labels: {
      // This more specific font property overrides the global property
      // fontColor: 'red'
    },
  },
};
